var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.getPage ? _c('div', [_c('Banner', {
    attrs: {
      "page": _vm.getPage
    }
  }), _c('section', {
    staticClass: "description events-page-wrap clearfix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-12",
    domProps: {
      "innerHTML": _vm._s(_vm.getPage.contents)
    }
  })])])])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }